export default __webpack_public_path__ + "e797946efb6aa59e84119ab7377014ce.jpg";